/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoginResponseChallengeParametersStruct } from './LoginResponseChallengeParametersStruct';
import {
    LoginResponseChallengeParametersStructFromJSON,
    LoginResponseChallengeParametersStructFromJSONTyped,
    LoginResponseChallengeParametersStructToJSON,
    LoginResponseChallengeParametersStructToJSONTyped,
} from './LoginResponseChallengeParametersStruct';
import type { AuthenticationResult } from './AuthenticationResult';
import {
    AuthenticationResultFromJSON,
    AuthenticationResultFromJSONTyped,
    AuthenticationResultToJSON,
    AuthenticationResultToJSONTyped,
} from './AuthenticationResult';

/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof LoginResponse
     */
    readonly $schema?: string;
    /**
     * 
     * @type {AuthenticationResult}
     * @memberof LoginResponse
     */
    authenticationResult: AuthenticationResult;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    challengeName: string;
    /**
     * 
     * @type {LoginResponseChallengeParametersStruct}
     * @memberof LoginResponse
     */
    challengeParameters: LoginResponseChallengeParametersStruct;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    session: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    username: string;
}

/**
 * Check if a given object implements the LoginResponse interface.
 */
export function instanceOfLoginResponse(value: object): value is LoginResponse {
    if (!('authenticationResult' in value) || value['authenticationResult'] === undefined) return false;
    if (!('challengeName' in value) || value['challengeName'] === undefined) return false;
    if (!('challengeParameters' in value) || value['challengeParameters'] === undefined) return false;
    if (!('session' in value) || value['session'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function LoginResponseFromJSON(json: any): LoginResponse {
    return LoginResponseFromJSONTyped(json, false);
}

export function LoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'authenticationResult': AuthenticationResultFromJSON(json['authenticationResult']),
        'challengeName': json['challengeName'],
        'challengeParameters': LoginResponseChallengeParametersStructFromJSON(json['challengeParameters']),
        'session': json['session'],
        'username': json['username'],
    };
}

export function LoginResponseToJSON(json: any): LoginResponse {
    return LoginResponseToJSONTyped(json, false);
}

export function LoginResponseToJSONTyped(value?: Omit<LoginResponse, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authenticationResult': AuthenticationResultToJSON(value['authenticationResult']),
        'challengeName': value['challengeName'],
        'challengeParameters': LoginResponseChallengeParametersStructToJSON(value['challengeParameters']),
        'session': value['session'],
        'username': value['username'],
    };
}

